import {TheCryptSymbol, ISymbolData, TheCryptSymbolStates} from "./TheCryptSymbol";
import {TimelineLite} from "gsap";
import {TheCrypt} from "../TheCrypt";
import {TheCryptHelper} from "../utils/TheCryptHelper";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {TheCryptSoundManager} from "../sound/TheCryptSoundManager";

export class TheCryptScatter extends TheCryptSymbol {
    private _isPlayingTrigger: boolean;
    private _isPlayingAttention: boolean;
    private _currentAnimation: string;

    constructor(symbolData: ISymbolData, state: TheCryptSymbolStates = TheCryptSymbolStates.NORMAL) {
        super(symbolData);
        this._isPlayingTrigger = false;
        this._isPlayingAttention = false;
        this._currentAnimation = "";
        this.getStateAnimation(state);
    }

    private set isPlayingAttention(value: boolean) {
        if (this._isPlayingAttention) {
            return;
        }
        if (!this.parent) {
            debugger;
        }
        this.parent.removeChild(this);
        TheCrypt.realArea.allReels[this.reelId].reelView.scatterWinView.addChild(this);
        this._isPlayingAttention = true;
    }

    public playLandingAnimation(): TimelineLite {
        return new TimelineLite().add([
            () => {
                this._currentAnimation = "base";
                this._spine?.state.setAnimation(0, "base", true);
            },
            new SpineTween(this._spine!, 2, "land")
        ]).add(() => {
            this._spine?.state.setEmptyAnimation(2, 0)
        });
    }

    public playWin(): TimelineLite {
        this._isPlayingTrigger = true;
        this._currentAnimation = "win";
        return new TimelineLite().add([
            () => {
                TheCryptSoundManager.playScatterFlashSound();
            },
            new SpineTween(this._spine!, 1, "win")
        ], 1);
    }

    public playPlusThree(): void {
        if (!this._isPlayingAttention && !this._isPlayingTrigger) {
            if (!this.parent) {
                debugger;
            }
            this.parent.removeChild(this);
            TheCrypt.realArea.allReels[this.reelId].reelView.scatterWinView.addChild(this);
        }
        this._isPlayingAttention = true;
        this._currentAnimation = "trigger_4_loop";
        this._spine?.state.setEmptyAnimation(1, 0.2);
        new TimelineLite().add(new SpineTween(this._spine!, 0, "trigger_4"))
            .add(() => {
                this._spine!.state.setAnimation(0, "trigger_4_loop", true);
            });
    }

    public playScatterAttention(): TimelineLite {
        this.isPlayingAttention = true;
        this._currentAnimation = "attention";
        this._spine?.state.setAnimation(1, "attention", true);
        return new TimelineLite();
    }

    public playScatterTrigger(): void {
        this._isPlayingAttention = true;
        this._spine?.state.setEmptyAnimation(1, 0.2);
        this._currentAnimation = "trigger_3_loop";
        new TimelineLite().add(new SpineTween(this._spine!, 0, "trigger_3"))
            .add(() => {
                this._spine!.state.setAnimation(0, "trigger_3_loop", true);
            });
    }

    public remove(): TheCryptSymbol {
        this.reset();
        return super.remove();
    }

    public reset(): void {
        TheCryptHelper.resetSpineItem(this._spine!);
    }

    public stopAnimation(fsWon: boolean): void {
        if (!fsWon) {
            if (this._currentAnimation != "base" || this._isPlayingAttention) {
                this._spine?.state.setAnimation(0, "base", true);
                this._spine?.state.setEmptyAnimation(1, 0.2);
            }
            this._currentAnimation = "base";
            this._isPlayingAttention = false;
        }
    }

    public setRestoreState(): void {
        this._currentAnimation = "base";
    }

    public setRestoreState3(i: number): void {
        this.isPlayingAttention = true;
        if (i < 3) {
            this._currentAnimation = "trigger_3_loop";
            this._spine!.state.setAnimation(0, "trigger_3_loop", true);
        } else {
            this._currentAnimation = "trigger_4_loop";
            this._spine!.state.setAnimation(0, "trigger_4_loop", true);
        }
    }

    public setRestoreState2(i: number): void {
        this.isPlayingAttention = true;
        this._currentAnimation = "attention";
        this._spine?.state.setAnimation(0, "base", true);
        this._spine?.state.setAnimation(1, this._currentAnimation, true);
    }

    public setSymbolState(symbolData: ISymbolData): void {
        if (!symbolData) {
            return;
        }

        if (this._currentAnimation.length === 0) {
            this._currentAnimation = "base";
            this._spine?.state.setAnimation(0, "base", true);
            return;
        }

        if (this._currentAnimation === "base") {
            return;
        }

        switch (this._currentAnimation) {
            case "win":
                this._spine?.state.setAnimation(1, this._currentAnimation, false);
                break;
            case "attention":
                this._spine?.state.setAnimation(0, "base", true);
                this._spine?.state.setAnimation(1, this._currentAnimation, true);
                break;
            case "trigger_4_loop":
                this._spine!.state.setAnimation(0, "trigger_4_loop", true);
                break;
            case "trigger_3_loop":
                this._spine!.state.setAnimation(0, "trigger_3_loop", true);
                break;
        }
    }
}